import React, { useState, useEffect } from 'react';
import MiniHeader from '../components/MiniHeader';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { fetcher } from '../api';
import { API_URLS, BASE_IMAGE_URL } from '../api/url';

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [filteredImages, setFilteredImages] = useState([]);
  const [galleryData, setGalleryData] = useState(null);
  const [index, setIndex] = useState(-1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchImages = async () => {
    setLoading(true);
    try {
      const response = await fetcher(API_URLS.GALLERY);
      const formattedImages = response.images.map((img) => ({
        id: img.id,
        url: `${BASE_IMAGE_URL}${img.url}`,
        title: img.title,
        width: img.width,
        height: img.height,
      }));
      setGalleryData(response);
      setImages(formattedImages);
      setFilteredImages(formattedImages);
      setLoading(false);
    } catch (error) {
      setError('Failed to load images');
      setLoading(false);
    }
  };

  const preloadImages = (images) => {
    images.forEach((image) => {
      const img = new Image();
      img.src = image.url;
    });
  };

  useEffect(() => {
    fetchImages();
  }, []);

  useEffect(() => {
    if (images.length > 0) {
      preloadImages(images);
    }
  }, [images]);

  const openLightbox = (index) => {
    setIndex(index);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <MiniHeader title={"Gallery"} />
      <div id="portfolio" className="gallery">
        <div className="container">
          <div className="session-title row">
            <h2>Our Gallery</h2>
            <p>{galleryData?.description || "Explore our stunning captures, showcasing the beauty of nature, adventure, and unforgettable moments."}</p>
            <div className="heading-line"></div>
          </div>

          {/* Gallery Images */}
          <div className="row">
            {filteredImages.map((img, idx) => (
              <div
                key={img.id}
                className="gallery_product col-lg-3 col-md-3 col-sm-4 col-xs-6 filter"
                onClick={() => openLightbox(idx)}
                style={{ cursor: "pointer" }}
              >
                <img src={img.url} className="img-responsive" alt={img.title || `Gallery Item ${idx + 1}`} />
              </div>
            ))}
          </div>
        </div>

        {/* Lightbox Modal */}
        <Lightbox
          open={index >= 0}
          close={() => setIndex(-1)}
          index={index}
          slides={filteredImages.map(img => ({ src: img.url }))}
        />
      </div>
    </>
  );
};

export default Gallery;